import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const WebPayButton = ({ webpayToken }) => {

  const [webpayUrl, setWebpayUrl] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    if (webpayToken.token) {
      setToken(webpayToken.token);
      setWebpayUrl(webpayToken.url);
    }
  }, [webpayToken.token, webpayToken.url]);

  useEffect(() => {
    if (webpayUrl !== '') {
      document.getElementById('webpay_form').submit();
    }
  }, [webpayUrl]);

  return (
    <form id='webpay_form' method="post" action={webpayUrl}>
      <input type="hidden" name="token_ws" value={token} />
    </form>
  );
};

WebPayButton.propTypes = {
  webpayToken: PropTypes.object.isRequired,
};

const data = (state) => ({
  webpayToken: state.webpay.webpayToken,
});

export default connect(data, null)(WebPayButton);